/**
 * @fileoverview A function for submitting a verification to Google.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */

import Uri from 'goog:goog.Uri';
import json from 'goog:goog.json';

import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {doRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/dorequest';
import {ResponseError} from '/src/com/yext/listingslaunchstorm/js/data/responseerror';
import {SubmitVerificationToPublisherRequest} from '/src/com/yext/listingslaunchstorm/js/data/submitverificationtopublisherrequest';

/**
 * @param {!SubmitVerificationToPublisherRequest} request
 * @param {string} testCase
 * @param {AbortSignal} abortSignal
 * @return {!Promise}
 */
const submitVerificationToPublisher = (request, testCase, abortSignal) => {
  const uri = new Uri(Routes.submitVerificationToPublisher());
  return doRequest('submitVerificationToPublisher', abortSignal, uri, 'POST', request)
    .then(response => ResponseError.fromJSON(response, JSON.parse));
};

export default submitVerificationToPublisher;
